<div id=pogo-zone-tab-container [ngClass]="{'is-disabled': count < 1, 'is-mini-mode': isMiniMode}">
    <div id="zone-ico-container" [ngStyle]="{'color': ratingColor}">
        <fa-icon icon="circle"></fa-icon>
        <span [class]="ratingIcon"></span>
    </div>
    <div id="zone-rating" *ngIf="isMiniMode">{{ratingText | translate}}</div>
    <div id="zone-count">{{count || 0}}</div>
</div>
